import React, { useEffect, useState } from "react";
import DTOLeaveEligibilityModal from "./DTOLeaveEligibilityModal";
import LeaveEligibilityModalPresenter from "./LeaveEligibilityModalPresenter";
import { useAppDispatch, useAppSelector } from "../../../../infra/hooks";
import { aboutMeType } from "../../../interfaces/myProfile/personalDetails/aboutMeType";
import { leavesService } from "../../../../api/services/leavesService";
import { toast } from "react-hot-toast";
import browserTimeZone from "../../../../api/services/localtime";

interface ModalInterface {
  isModalOpen: boolean;
  closeModal: any;
  trans:any;
}

const LeaveEligibilityModalController = ({
  isModalOpen,
  closeModal,
  trans
}: ModalInterface) => {
  const aboutMe_data = useAppSelector((state) => state.aboutMeSlice.about_me);
  const selector = useAppSelector((state) => state);

  const [leaveTypes, setLeaveTypes] = useState([]);
  const dispatch = useAppDispatch();

  const getData = (data: any) => {
    applyLeaveEncash(data);
  };

  const getLeaveTypeData = (data: any) => {
    setLeaveTypes(data);
  };

  async function applyLeaveEncash(data: any) {
    const empID: any = selector.authSlice.emp_id;
    const companyID: any = selector.authSlice.company_id;

    // dispatch(setRefreshLeaveApplied(true));
    const formData = new FormData();
    if (empID && companyID && data.leaveValue && data.leaveDays) {
      formData.append("emp_id", empID);
      formData.append("company_id", companyID);
      formData.append("leave_value", data.leaveValue);
      formData.append("leave_type_id", data.leaveTypeId);
      formData.append("start_date", data.startDate);
      formData.append("end_date", data.endDate);
      formData.append("days", data.leaveDays);
      formData.append("leave_reason", data.note);
      formData.append("attachment", data.file);
      formData.append("timezone", browserTimeZone);
      await leavesService
        .applyLeave(formData)
        .then((response) => {
          if (response.response == "success") {
            toast.success(trans("Leave Encashment Applied Successfully"));
          }
        })
        .catch((err) => {
          console.log("Catch", err);
          // dispatch(setRefreshLeaveApplied(false));
          const _errors =
            err?.response?.data?.errors &&
            Object.keys(err?.response?.data?.errors);
          toast.error(
            err?.response?.data?.errors
              ? `${_errors.toString().toUpperCase()} Required!`
              : err?.response?.data?.data
              ? err?.response?.data?.data
              : err?.response?.data?.message
          );
        });
    } else {
      // dispatch(setRefreshLeaveApplied(false));
      toast.error(trans("Please fill the missing fields!"));
    }
  }
  // async function updateAboutMeFunc(data: aboutMeType) {
  //   if (empId) {
  //     const payload = {
  //       emp_id: empId,
  //       about_me: data.about_me,
  //     };
  //     const response: any = await updatePersonalDetailsService.updateAboutMe(
  //       payload
  //     );
  //     if (response.status == "success") {
  //       const about_me_data: aboutMeType = {
  //         about_me: response.data,
  //       };
  //       dispatch(updateAboutMe(about_me_data));
  //       console.log("Selector--", selector);
  //     }
  //   } else {
  //     alert("No employee id!");
  //   }
  // }

  return (
    <div>
      <DTOLeaveEligibilityModal setAllLeaveTypesData={getLeaveTypeData} />

      <LeaveEligibilityModalPresenter
        trans={trans}
        callBackGetData={getData}
        isModalOpen={isModalOpen}
        closeModal={closeModal}
        allLeaveTypes={leaveTypes}
      />
    </div>
  );
};

export default LeaveEligibilityModalController;
